import { ConfigDataInterface } from './ConfigApiInterface';

export enum Config_Clubs_ActionsMenu_ApiEnum {
    'create_club' = 'create_club',
}

export enum Config_Clubs_Modules_ApiEnum {
    'results' = 'results',
}

export enum Config_Clubs_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_Clubs_PageMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_Clubs_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_Clubs_ApiInterface
    extends ConfigDataInterface<
        Config_Clubs_Modules_ApiEnum,
        Config_Clubs_ActionsMenu_ApiEnum,
        Config_Clubs_ActionsOther_ApiEnum,
        Config_Clubs_PageMenu_ApiEnum,
        Config_Clubs_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
